import Modal from '@mui/material/Modal';
import clsx from 'clsx';
import React from 'react';

import TheInformationLogo from 'images/the-information-logo.svg';

const TIModal = (props) => {
  const {
    children,
    isFullScreen = false,
    isOpen,
    onClose,
    parentClass,
    withLogo = false,
    disableScrollLock,
    customHeader = false,
    ...newProps
  } = props;
  return (
    <Modal open={isOpen} onClose={onClose} disableScrollLock={disableScrollLock} {...newProps}>
      <div
        className={clsx(
          'TIModal',
          'tw-absolute tw-top-1/2 tw-left-1/2 -tw-translate-y-1/2 -tw-translate-x-1/2 tw-z-[1000] tw-rounded-2 tw-max-h-full',
          parentClass,
          {
            'tw-h-screen tw-max-w-full xs:tw-h-auto': isFullScreen,
            'tw-h-auto tw-px-16 tw-max-w-full': !isFullScreen,
          }
        )}
      >
        <div
          className={clsx('modal-container tw-bg-background-white', {
            'tw-justify-start tw-h-full xs:tw-justify-center xs:tw-h-auto': isFullScreen,
            'tw-justify-center tw-h-auto': !isFullScreen,
          })}
        >
          {!customHeader ? (
            <>
              <button className="close-button" onClick={onClose}></button>
              <div className="wrapper">
                {withLogo && (
                  <div className="logo-header">
                    <img src={TheInformationLogo} width={225} />
                  </div>
                )}
                {children}
              </div>
            </>
          ) : (
            <>{children}</>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default TIModal;
